import { render, staticRenderFns } from "./creation.vue?vue&type=template&id=047be268&scoped=true"
import script from "./creation.vue?vue&type=script&lang=js"
export * from "./creation.vue?vue&type=script&lang=js"
import style0 from "./creation.vue?vue&type=style&index=0&id=047be268&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047be268",
  null
  
)

export default component.exports